// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const productionMaster = [
  {
    title: 'Garment Category',
    path: '/dashboard/masters/GarmentCategoryMst',
    icon: icon('gtype'),
    ShortName: 'Masters_GarmentType',
  },
  {
    title: 'Garments Description',
    path: '/dashboard/masters/GarmentDescription',
    icon: icon('garment'),
    ShortName: 'Masters_Garments',
  },
  {
    title: 'Machine',
    path: '/dashboard/masters/machine',
    icon: icon('sewing'),
    ShortName: 'Masters_Machine',
  },
  {
    title: 'Operation Group',
    path: '/dashboard/masters/group',
    icon: icon('op'),
    ShortName: 'Masters_OperationGroup',
  },
  {
    title: 'Operation',
    path: '/dashboard/masters/operation',
    icon: icon('operation'),
    ShortName: 'Masters_Operation',
  },
  {
    title: 'Rate Card',
    path: '/dashboard/masters/rate_card',
    icon: icon('rate'),
    ShortName: 'Masters_RateCard',
  },
  {
    title: 'Line/Batch',
    path: '/dashboard/masters/line',
    icon: icon('line2'),
    ShortName: 'Masters_Batch_Line',
  },
  {
    title: 'Grade',
    path: '/dashboard/masters/grade',
    icon: icon('line2'),
    ShortName: 'Masters_grade',
  },
  // {
  //   title: 'Operation Category',
  //   path: '/dashboard/masters/category',
  //   icon: icon('education-bag'),
  // },
];

export default productionMaster;
